var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasNewVersion)?_c('Info',{staticClass:"version-update"},[_vm._v(" New version of the app is available, please "),_c('a',{staticClass:"refresh-link",attrs:{"href":"#"},on:{"click":_vm.reload}},[_vm._v(" click here to refresh app")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }